module.exports = __webpack_public_path__ + "static/media/handshake.b2066988.png";